import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { inject, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { validationRules } from "@/ValidationRules";
import { CustomerServiceSymbol, LedgerServiceSymbol, OrderServiceSymbol } from "@/InjectionSymbols";
import AdminCreateOrderDto from "@/dto/AdminCreateOrderDto";
import { PaymentMethod } from "@/model/enum/PaymentMethod";
import { useMessageStore } from "@/stores/MessageStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewOrderView',
    setup(__props) {
        const orderService = inject(OrderServiceSymbol);
        const ledgerService = inject(LedgerServiceSymbol);
        const customerService = inject(CustomerServiceSymbol);
        const customers = reactive([]);
        const createOrder = reactive(new AdminCreateOrderDto());
        const ledgers = reactive([]);
        const router = useRouter();
        const messageStore = useMessageStore();
        let form = ref(null);
        let saveInFlight = ref(false);
        onMounted(() => {
            customerService?.getAllCustomers(customersLoaded);
            ledgerService?.loadAllLedgers().then(ledgersResponse => {
                ledgers.length = 0;
                ledgers.push(...ledgersResponse);
            });
        });
        function customersLoaded(response) {
            customers.length = 0;
            response.forEach(customer => {
                customers.push(customer);
            });
        }
        function save() {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    orderService.createAdminOrder(createOrder)
                        .then((response) => {
                        messageStore.addMessage("Buchung erstellt");
                        router.push('/admin/orders/' + response.data.id);
                    })
                        .finally(() => saveInFlight.value = false);
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "ma-0" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: true,
                        class: "text-h4 text-start"
                    }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("Neue Buchung anlegen")
                        ])),
                        _: 1
                    }),
                    _createVNode(_component_v_form, {
                        ref_key: "form",
                        ref: form
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "d-flex flex-wrap ml-0 w-50 pa-0" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_autocomplete, {
                                        rules: [_unref(validationRules).required],
                                        class: "compact v-col-12",
                                        modelValue: createOrder.customer,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((createOrder.customer) = $event)),
                                        items: customers,
                                        "item-title": "email",
                                        placeholder: "Kunden nach Email auswählen",
                                        label: "Kunde",
                                        variant: "outlined",
                                        density: "compact",
                                        "return-object": "",
                                        "data-cy": "customer"
                                    }, {
                                        "append-inner": _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/admin/customers/new')))
                                            }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                    _createTextVNode("Neu")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 8, ["rules", "modelValue", "items"]),
                                    _createVNode(_component_v_select, {
                                        class: "compact v-col-4",
                                        density: "compact",
                                        modelValue: createOrder.ledger,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((createOrder.ledger) = $event)),
                                        items: ledgers,
                                        "item-title": "ledgerName",
                                        label: "Konto",
                                        variant: "outlined",
                                        rules: [_unref(validationRules).required],
                                        "return-object": "",
                                        "data-cy": "ledger"
                                    }, null, 8, ["modelValue", "items", "rules"]),
                                    _createVNode(_component_v_select, {
                                        density: "compact",
                                        class: "compact v-col-8",
                                        items: Object.values(_unref(PaymentMethod)).filter(v => v != _unref(PaymentMethod).SUMUP).map(v => ({ title: _ctx.$t(v), value: v })),
                                        modelValue: createOrder.paymentMethod,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((createOrder.paymentMethod) = $event)),
                                        rules: [_unref(validationRules).required],
                                        label: "Zahlungsmethode",
                                        variant: "outlined",
                                        "data-cy": "paymentMethod"
                                    }, null, 8, ["items", "modelValue", "rules"]),
                                    _createVNode(_component_v_textarea, {
                                        class: "v-col-12 compact",
                                        label: "Anmerkungen des Kunden",
                                        rules: [_unref(validationRules).maxLength(1000)],
                                        "no-resize": "",
                                        rows: "4",
                                        modelValue: createOrder.customerRemarks,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((createOrder.customerRemarks) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        "data-cy": "customerRemarks"
                                    }, null, 8, ["rules", "modelValue"]),
                                    _createVNode(_component_v_textarea, {
                                        class: "v-col-12 compact",
                                        modelValue: createOrder.internalRemarks,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((createOrder.internalRemarks) = $event)),
                                        rules: [_unref(validationRules).maxLength(1000)],
                                        density: "compact",
                                        variant: "outlined",
                                        label: "Interne Anmerkungen",
                                        "data-cy": "internalRemarks"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_v_btn, {
                                        class: "ml-4 mb-4",
                                        onClick: save,
                                        "data-cy": "create-order"
                                    }, {
                                        default: _withCtx(() => [
                                            (!_unref(saveInFlight))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Buchung anlegen"))
                                                : _createCommentVNode("", true),
                                            (_unref(saveInFlight))
                                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                    key: 1,
                                                    indeterminate: true
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 512)
                ]),
                _: 1
            }));
        };
    }
});
